import React from 'react';
import { SignUp } from '@clerk/clerk-react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useBranding } from 'modules/App/hooks/useBranding';
import { appendRedirectUrl, getSafeRedirectUrl } from 'modules/Auth/redirectUrl';
import { supplierAwareAfterAuthUrl } from 'modules/FreeSupplier/routes';
import { buildClerkAppearance } from 'modules/Common/config/clerkAppearance';
import { isDarkSurfaceWhiteTextBrand } from 'modules/Common/utils/brandColor';
import AuthShell from 'modules/Auth/components/AuthShell';

const SignUpPage = () => {
  const { t } = useTranslation();
  const brand = useBranding();
  // Footer sits on AuthShell's dark backdrop — near-black brand primaries
  // fall back to white, same rule as the shell's own accents.
  const linkColor = isDarkSurfaceWhiteTextBrand(brand.key) ? 'text-white' : 'text-primaryColor';
  const redirectUrl = getSafeRedirectUrl();
  const afterSignUpUrl = supplierAwareAfterAuthUrl(redirectUrl);
  const signInUrl = appendRedirectUrl('/sign-in', redirectUrl);

  return (
    <AuthShell
      footer={
        <p className="mt-3 text-center text-sm text-white/60 lg:hidden">
          {t('auth.haveAccountPrompt', 'Already have an account?')}{' '}
          <Link
            to={signInUrl}
            className={`font-medium hover:underline ${linkColor}`}
          >
            {t('auth.signInLink', 'Sign in')}
          </Link>
        </p>
      }
    >
      <SignUp
        signInUrl={signInUrl}
        afterSignUpUrl={afterSignUpUrl}
        afterSignInUrl={afterSignUpUrl}
        appearance={buildClerkAppearance(brand)}
      />
    </AuthShell>
  );
};

export default SignUpPage;
